const layout = {
  shell: {
    title: 'Quadralize Backoffice',
    description: 'Central administrativa para operações do Quadralize.',
  },
  navigation: {
    dashboard: 'Visão geral',
    companies: 'Empresas',
    companyProfile: 'Perfil da empresa',
    origins: 'Origens',
    users: 'Usuários',
  },
  routeLoader: {
    label: 'Carregando...',
  },
  authGate: {
    redirecting: 'Redirecionando...',
  },
  header: {
    homeAriaLabel: 'Ir para a visão geral',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
  },
  userMenu: {
    profile: 'Perfil',
    settings: 'Configurações',
    logout: 'Sair',
  },
}

export default layout
